import React from 'react';
import PropTypes from 'prop-types';

// Import JSX Modules
import DeliveryOptionFilters from './delivery-option-filters';
import Filter from './filter';
import ClearFilters from './clear-filters';
import Search from './search';
import classNames from 'classnames';
import Sort from './sort';

// -----------------------------------------------------------
//  Filters
// -----------------------------------------------------------
function Filters({
  category,
  default_search_term,
  delivery_options,
  facets,
  favouriteFilters,
  filters,
  handleSortChange,
  hideFilterModal,
  onClearAllFilters,
  onCollapseFilter,
  onSearchChange,
  selectedFiltersCount,
  selected_delivery_options,
  selected_filters,
  sortBy,
  totalProducts
}) {
  const getAllFiltersLabel = () => {
    if (selectedFiltersCount > 0) {
      return `(${selectedFiltersCount})`;
    }
  };

  const handleClearAllFilters = () => {
    onClearAllFilters();
  };

  const handleShowFilters = () => {
    hideFilterModal();
  };

  return (
    <div>
      <div className="shelf-filters">
        <div className="d-none d-md-block bottom-border row m-0 menu-ribbon">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-12 p-0">
                <ul className="d-flex flex-wrap mt-3 list-unstyled" role="list">
                  <button
                    className={classNames('btn shelf-filter-dropdown-toggle m-1', {
                      'has-option-selected': selectedFiltersCount > 0,
                    })}
                    onClick={handleShowFilters}>
                    <i className="mr-2">
                      <svg
                        className="filter-sandwich"
                        viewBox="0 0 16 14"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M0 1.1396C0 0.509259 0.510714 0 1.14286 0H14.8571C15.4893 0 16 0.509259 16 1.1396C16 1.76994 15.4893 2.2792 14.8571 2.2792H1.14286C0.510714 2.2792 0 1.76994 0 1.1396ZM0 6.83761C0 6.20726 0.510714 5.69801 1.14286 5.69801H14.8571C15.4893 5.69801 16 6.20726 16 6.83761C16 7.46795 15.4893 7.97721 14.8571 7.97721H1.14286C0.510714 7.97721 0 7.46795 0 6.83761ZM16 12.5356C16 13.166 15.4893 13.6752 14.8571 13.6752H1.14286C0.510714 13.6752 0 13.166 0 12.5356C0 11.9053 0.510714 11.396 1.14286 11.396H14.8571C15.4893 11.396 16 11.9053 16 12.5356Z"
                          fill="currentColor"
                        />
                      </svg>
                    </i>
                    All Filters {getAllFiltersLabel()}
                  </button>
                  <DeliveryOptionFilters
                    options={delivery_options}
                    facets={(facets || {})['faceted_delivery_options']}
                    selected_options={selected_delivery_options || []}
                    filter_name="delivery_options"
                    onClickCollapsed={onCollapseFilter}
                  />
                  {filters.map(filter => {
                    const { key } = filter;
                    if ((facets || {})['filter_' + key].length == 0) {
                      return null;
                    }
                    return (
                      <Filter
                        {...filter}
                        key={key}
                        name={key}
                        title={filter.label}
                        options={filter.options}
                        category={category}
                        facets={(facets || {})['filter_' + key]}
                        selected_options={selected_filters[key] || []}
                        filter_name={key}
                      />
                    );
                  })}
                  {favouriteFilters}
                  {selectedFiltersCount > 0 && (
                    <ClearFilters
                      onClearAllFiltersClick={handleClearAllFilters}
                    />
                  )}
                  <Sort
                    value={sortBy}
                    onChange={handleSortChange}
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 ml-1">
          <div className="d-none d-md-block">
            <h3 className="category-information ml-1 mb-2">
              {`${category} (${totalProducts})`}
            </h3>
          </div>
        </div>
        <div className="row d-none d-md-block horizontal-dropdown ml-1">
          <Search
            defaultTerm={default_search_term}
            onChange={onSearchChange}
            categoryName={category}
          />
        </div>
      </div>
    </div>
  );
}

export default Filters;
